import { z } from "zod";

export const systemEventSchema = z.discriminatedUnion("event", [
	z.object({ event: z.literal("member_joined") }),
	z.object({ event: z.literal("member_left") }),
]);

export type SystemEventData = z.infer<typeof systemEventSchema>;
